<template>
  <ankh-list :showBtnGroup="false">

    <template #btn-group>
      <el-button icon="el-icon-plus">{{ $t('新增') }}</el-button>
      <el-button icon="el-icon-delete" @click.native="handleBatchDelete">{{ $t('删除') }}</el-button>
    </template>

    <template #search-form>
      <el-form-item :label="$t('订单号')">
        <el-input :placeholder="$t('订单号')" v-model="searchForm.num" clearable />
      </el-form-item>

      <el-form-item :label="$t('菜谱编号')">
        <el-input :placeholder="$t('菜谱编号')" v-model="searchForm.cookbookNum" clearable />
      </el-form-item>
      <el-form-item :label="$t('订单内容')">
        <dict-select clearable v-model="searchForm.orderType" flag="ORDER_TYPE" />
      </el-form-item>
      <el-form-item :label="$t('类型')">
        <dict-select clearable v-model="searchForm.type" flag="DEAL_TYPE" />
      </el-form-item>

      <el-form-item :label="$t('交易状态')">
        <dict-select clearable v-model="searchForm.status" flag="ORDER_STATUS" />
      </el-form-item>

      <el-form-item :label="$t('交易方式')">
        <dict-select clearable v-model="searchForm.payType" flag="PAY_TYPE" />
      </el-form-item>

      <el-form-item :label="$t('交易时间')">
        <date-time-range-picker
            :start-time.sync="searchForm.startCreateTime"
            :end-time.sync="searchForm.endCreateTime" />
      </el-form-item>


      <el-form-item>
        <el-button type="primary" @click="$refs.list.handleSearch()">{{ $t('搜索') }}</el-button>
        <el-button @click="$refs.list.reset()">{{ $t('重置') }}</el-button>
      </el-form-item>
    </template>

    <template #table="{height}">

      <table-list
          :height="height"
          ref="list"
          row-key="id"
          :search-params="searchForm"
          :data="tableData"
          @query="handleSearch"
          :request-params="{bothUserNum: $route.query.num}"
          @selection-change="selection = $event">

        <el-table-column type="selection" width="50" />
        <el-table-column align="center" prop="num" :label="$t('订单号')" />
        <el-table-column :label="$t('用户编号')" prop="userNum" />
        <el-table-column :label="$t('用户昵称')" prop="username" />
        <el-table-column align="center" prop="cookbookNum" :label="$t('菜谱编号')" />
        <el-table-column align="center" :label="$t('菜谱缩略图')">
          <template v-slot="{row}">
            <preview-img :size="40" :img-url="row.cookbookCover" />
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('订单内容')">
          <template v-slot="{row}">
            <dict-text :status="row.orderType" dict-flag="ORDER_TYPE" />
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('交易方式')">
          <template v-slot="{row}">
            <dict-text :status="row.payType" dict-flag="PAY_TYPE" />
          </template>
        </el-table-column>
        <el-table-column align="center" prop="price" :label="$t('金额')" />
        <el-table-column align="center" prop="name" :label="$t('类型')">
          <template v-slot="{row}">
            <dict-text :status="row.type" dict-flag="DEAL_TYPE" />
          </template>
        </el-table-column>
        <el-table-column align="center" prop="name" :label="$t('交易状态')">
          <template v-slot="{row}">
            <dict-text :status="row.status" dict-flag="ORDER_STATUS" />
          </template>
        </el-table-column>
        <el-table-column align="center" prop="name" :label="$t('交易时间')">
          <template v-slot="{row}">
            {{row.createTime | formatDate}}
          </template>
        </el-table-column>
      </table-list>
    </template>
  </ankh-list>
</template>

<script>
import TableList from "@/components/table-list/TableList";
import {request} from "@/config/request";
import DateTimeRangePicker from "@/components/time/DateTimeRangePicker";
import PreviewImg from "@/components/preview-img/PreviewImg.vue";
import DictText from "@/components/dict/DictText.vue";
import DictSelect from "@/components/dict/DictSelect.vue";
import AnkhList from "@/components/list/AnkhList.vue";
export default {
  name: "UserDealList",
  components: {AnkhList, DictSelect, DictText, PreviewImg, DateTimeRangePicker, TableList},
  data() {
    return {
      searchForm: {},
      tableData: [],
      selection: [],
    }
  },
  methods: {
    async handleSearch(params, setTotal) {
      try {
        let res = await request(this.$api.anOrder.listMy, params);
        this.tableData = res.anOrders.map(item => {
          // 判断类型，如果两个userNum 不相等需要反转
          const {userNum, receiveUserNum} = item;
          if(receiveUserNum && userNum !== receiveUserNum) {
            item.type = item.type === "out" ? "in" : "out";
          }
          return item;
        })
        setTotal(res.pager.itemCount);
      }catch(e) {
        console.log(e);
      }
    }
  },
}
</script>

<style scoped>

</style>
